import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './uiReducer';
import authReducer from './authReducer';
import cartReducer from './cartReducer';

export default configureStore({
    reducer: {
        ui: uiReducer,
        auth: authReducer,
        cart: cartReducer
    }
});
